module.exports = __webpack_public_path__ + "img/missionaries33_2019_7-7-2021.fdb46d15.jpg";